export enum AlertTypeEnum {
  LOAD = 0,
  DELIVERED_SHIP = 1,
  NEW_SCHEDULE_SHIP = 2,
  NO_MERCHANDISE = 3,
  MERCHANDISE_READY = 4,
  MERCHANDISE_DEVOLUTION = 5,
  SHIP_DELETED = 6,
  SHIP_VEHICLE_CHANGE = 7,
  SHIP_DELIVEY_DATE_CHANGE = 8
}
